import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M12.0129 16.24C11.855 16.2409 11.6984 16.2107 11.5522 16.1509C11.406 16.0912 11.273 16.0032 11.1609 15.892L5.35291 10.084C5.12695 9.85805 5 9.55158 5 9.23202C5 8.91245 5.12695 8.60598 5.35291 8.38002C5.57887 8.15405 5.88535 8.02711 6.20491 8.02711C6.52447 8.02711 6.83095 8.15405 7.05691 8.38002L12.0369 13.336L17.3889 8.32002C17.6216 8.1043 17.9302 7.98951 18.2473 8.00075C18.5644 8.012 18.8641 8.14836 19.0809 8.38002C19.2966 8.61269 19.4114 8.92132 19.4002 9.2384C19.3889 9.55548 19.2526 9.85521 19.0209 10.072L12.8289 15.88C12.6133 16.1004 12.3211 16.2293 12.0129 16.24Z' />
  </>,
  'Chevron'
)
